import { api } from "@/lib/api";

export async function getPlan() {
  const { data } = await api.get("/billing/plan");
  return data;
}

export async function getCheckoutStatus(sessionId) {
  const { data } = await api.get(`/billing/checkout/status/${sessionId}`);
  return data;
}
